import { CloseButton } from "react-bootstrap";

export const FormContentSection = ({
  children,
  className = "",
  title,
  ...props
}) => {
  return (
    <section className={`bg-white p-4 pb-5 rounded-4 border ${className}`}>
      <div className="d-flex justify-content-between mb-4">
        <h3>{title}</h3>
        <div
          className="bg-light d-flex justify-content-center align-items-center rounded-circle pe-cursor"
          style={{
            width: "1.75rem",
            height: "1.75rem",
          }}
        >
          <CloseButton />
        </div>
      </div>
      {children}
    </section>
  );
};
